import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=2b4495d2&scoped=true&"
import script from "./gift.vue?vue&type=script&lang=js&"
export * from "./gift.vue?vue&type=script&lang=js&"
import style0 from "./gift.vue?vue&type=style&index=0&id=2b4495d2&prod&scoped=true&lang=css&"
import style1 from "./gift.vue?vue&type=style&index=1&id=2b4495d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4495d2",
  null
  
)

export default component.exports